import { createRoute, redirect } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';
import { AlignmentFormEditPage } from '@/features/programs/program-alignment-form/AlignmentFormEditPage';
import {
  AlignmentFormFetchError,
  alignmentFormQueryOptions,
} from '@/features/programs/program-alignment-form/alignment-form-query';
import {
  ProgramByIdFetchError,
  programByIdQueryOptions,
} from '@/features/programs/program-edit/program-by-id-query';

/**
 * DEV-269 — "Alinhar vagas" → "Editar formulário". O construtor abre
 * carregado com o formulário de alinhamento do programa (AC-27); programa
 * inexistente/fora do escopo (404) volta para a listagem, como a tela de
 * gerenciamento.
 */
export const programAlignmentFormEditRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/programas/$programId/alinhamento/editar',
  component: AlignmentFormEditPage,
  loader: async ({ context, params }) => {
    try {
      await Promise.all([
        context.query.ensureQueryData(programByIdQueryOptions(params.programId)),
        context.query.ensureQueryData(alignmentFormQueryOptions(params.programId)),
      ]);
    } catch (err) {
      const notFound =
        (err instanceof ProgramByIdFetchError || err instanceof AlignmentFormFetchError) &&
        err.status === 404;
      if (notFound) {
        throw redirect({ to: '/programas', replace: true });
      }
      // Demais erros: a tela renderiza o estado de erro com "Tentar novamente".
    }
  },
});
